import { Button, DatePicker, Form, Modal } from 'antd';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { ErrorNotification } from '../../../../../../Utils/data';

import TextArea from 'antd/es/input/TextArea';
import { useCreateLetter } from '../../../../../../Hooks/TT_ELD/Mobile/Malfunction';

dayjs.extend(utc);

const Letter = ({ open, setOpen }: { open: boolean; setOpen(open: boolean): void }) => {
  const [form] = Form.useForm();

  const { mutate: createLetter, isLoading: creating } = useCreateLetter();

  const { id } = useParams<{ id: string }>();
  const { RangePicker } = DatePicker;

  const showModals = () => {
    setOpen(!open);
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        const range = values?.dateRange;
        const note = values?.note;

        const startDate = dayjs(range?.[0]).utc(true).startOf('day').toISOString();
        const endDate = dayjs(range?.[1]).utc(true).startOf('day').toISOString();

        const payload = {
          startDate,
          endDate,
          driverId: Number(id),
          note,
        };

        createLetter(payload, {
          onSuccess: (res: any) => {
            const link = res?.link;
            if (link) {
              window.open(link, '_blank', 'noopener,noreferrer');
              showModals();
              form.resetFields();
            } else {
              ErrorNotification({ status: 0, message: 'Link not found in response' });
            }
          },
          onError: (error: any) => {
            ErrorNotification({
              status: error?.response?.status,
              message:
                error?.response?.data?.error?.message || error?.message || 'Something went wrong',
            });
          },
        });
      })
      .catch(() => {});
  };

  const handleOk = handleSubmit;

  return (
    <>
      <Modal
        open={open}
        title="MALFUNCTION LETTER"
        onCancel={showModals}
        footer={[
          <Button key="back" onClick={showModals}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" disabled={creating} onClick={handleOk}>
            Submit
          </Button>,
        ]}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="dateRange"
            label="Date Range"
            rules={[{ required: true, message: 'Please select date range' }]}
          >
            <RangePicker
              style={{ width: '100%' }}
              format="YYYY-MM-DD"
              placement="bottomRight"
              getPopupContainer={() => document.body}
              popupClassName="responsive-range-picker-popup"
            />
          </Form.Item>

          <Form.Item
            name="note"
            label="Note"
            rules={[{ required: true, message: 'Please enter note' }]}
          >
            <TextArea rows={4} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default Letter;
